export const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];
export const ACCOUNT_TYPE_CHOICES = ['Cash', 'Bank', 'Credit Card', 'Other'];

export const TABLE_HEAD = [
  { id: 'name', label: 'Account Name', alignRight: false },
  { id: 'account_type', label: 'Type', alignRight: false },
  { id: 'balance', label: 'Balance', alignRight: false },
  { id: 'currency', label: 'Currency', alignRight: false },
  { id: 'is_active', label: 'Status', alignRight: false },
  { id: 'created_at', label: 'Created', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];

export const getInitialMoneyAccountFormData = () => ({
  name: '',
  account_type: '',
  currency: 'PKR',
  remarks: '',
  is_active: true,
});

export const getMoneyAccountFormDataFromRecord = (account) => ({
  name: account.name || '',
  account_type: account.account_type || '',
  currency: account.currency || 'PKR',
  remarks: account.remarks || '',
  is_active: account.is_active !== undefined ? account.is_active : true,
});

export const formatMoneyAccountDataForSubmission = (formData) => ({
  name: formData.name.trim(),
  account_type: formData.account_type,
  currency: formData.currency,
  remarks: formData.remarks.trim(),
  is_active: formData.is_active,
});